import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@node-real/icons';
export const Twitter = (props) => {
    return (_jsx(Icon, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 14", fill: "none", ...props, children: _jsx("path", { d: "M12.458 0H14.8329L9.64432 5.93026L15.7483 14H10.9689L7.22555 9.10574L2.94227 14H0.565856L6.1156 7.65692L0.26001 0H5.16073L8.54442 4.47354L12.458 0ZM11.6244 12.5785H12.9404L4.44565 1.34687H3.03345L11.6244 12.5785Z", fill: "currentColor" }) }));
};
